module.exports = {"TXTACL_Decrease":{"id":"TXTACL_Decrease","defaultMessage":"Sænk"},"TXTACL_Increase":{"id":"TXTACL_Increase","defaultMessage":"Hæv"}}